export default __webpack_public_path__ + "static/media/akthe_CA_789.61f5474e.png";